import { useRouter } from 'next/router';
import { useContext, type FC, type RefObject } from 'react';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { CLOUD_FRONT_IMAGE_PATH } from 'src/constants/imagePath';
import { I18nContext } from 'src/stores/I18n';
import { toJSX } from 'src/utils/toJSXHelper';
import { getVJWGuideLink } from 'src/utils/vjw';

type Props = {
  containerRef: RefObject<HTMLDivElement>;
};

export const VJWContent: FC<Props> = ({ containerRef }) => {
  const { locale } = useRouter();
  const localeResources = useContext(I18nContext);

  return (
    <div
      className="absolute right-[-200%] top-0 flex flex-col items-center gap-10 px-5 pb-[150px] max-h-[80vh] overflow-y-auto hidden-scrollbar w-screen max-w-[440px]"
      ref={containerRef}
    >
      <div>
        <p className="font-medium">{localeResources.receive.vjw.registrationRequired}</p>
        <div>{toJSX(localeResources.receive.vjw.counterInfo(getVJWGuideLink(locale)))}</div>
      </div>
      <div className="w-[243px] h-[415px] bg-gray-300 shrink-0">
        <NextImage src={`${CLOUD_FRONT_IMAGE_PATH}/shared/receive/vjw.webp`} alt="vjw" width={243} height={415} />
      </div>
    </div>
  );
};
